import React from "react";
import { Anchor, Box, Image, ResponsiveContext } from "grommet";
import moscowSport from "../../../Icons/Footer/moskomsport.svg";
import rusTriathlon from "../../../Icons/Footer/rustriathlon.svg";
import { NameSpace } from "../../../const/namespace";
import { IconSvg } from "../../IconSvg";
export var Partners = function Partners() {
  return /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
    return /*#__PURE__*/ React.createElement(
      Box,
      {
        direction: size !== NameSpace.mobile && size !== NameSpace.miniMobile ? "row" : "column",
        gap: size !== NameSpace.mobile && size !== NameSpace.miniMobile ? "20px" : "10px",
        align: size !== NameSpace.mobile && size !== NameSpace.miniMobile ? "center" : "start",
      },
      /*#__PURE__*/ React.createElement(
        Anchor,
        {
          href: "https://www.mos.ru/moskomsport/contacts/",
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            padding: "0",
          },
        },
        /*#__PURE__*/ React.createElement(Image, {
          src: moscowSport,
          width: "120px",
        })
      ),
      /*#__PURE__*/ React.createElement(
        Anchor,
        {
          href: "https://moscow.sport/news/",
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            padding: "0",
          },
        },
        /*#__PURE__*/ React.createElement(IconSvg, {
          src: "moscow",
          width: "120px",
          height: "32px",
        })
      ),
      /*#__PURE__*/ React.createElement(
        Anchor,
        {
          href: "https://rustriathlon.ru/",
          target: "_blank",
          rel: "noopener noreferrer",
          style: {
            padding: "0",
          },
        },
        /*#__PURE__*/ React.createElement(Image, {
          src: rusTriathlon,
          width: "120px",
        })
      )
    );
  });
};
